module.exports = __webpack_public_path__ + "img/badge.2270864e.svg";